import { reduxForm } from 'redux-form';

import FormContent from './FormContent';
import { FormContentOwnProps } from './FormContent.interfaces';
import { scrollToFirstInvalidField } from 'app/components/Form/scrollToFirstInvalidField';

export default reduxForm<{}, FormContentOwnProps>({
  onSubmitFail: scrollToFirstInvalidField,
  enableReinitialize: true,
})(FormContent);
